import { render, staticRenderFns } from "./left-tree.vue?vue&type=template&id=5acc7af2&scoped=true&"
import script from "./left-tree.vue?vue&type=script&lang=ts&"
export * from "./left-tree.vue?vue&type=script&lang=ts&"
import style0 from "./left-tree.vue?vue&type=style&index=0&id=5acc7af2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acc7af2",
  null
  
)

export default component.exports